<template>
    <div class="pd20">
        <div>
            <div class="mt20 mb20" style="font-weight: bolder;font-size: 2em;color: black;">
                隐私政策    
            </div>
            <div>
                <div>更新日期：2022/7/22</div>
                <div>生效日期：2022/7/22</div>
            </div>
        </div>
        <div>
            <div class="mt20 mb20" style="font-weight: bolder;font-size: 2em;color: black;">
                导言    
            </div>
            <div class="">
                <div class=""><div style="font-style: italic;">大虞建造 </div>是一款由 gumu （以下简称“我们”）提供的产品。 您在使用我们的服务时，我们可能会收集和使用您的相关信息。我们希望通过本《隐私政策》向您说明，在使用我们的服务时，我们如何收集、使用、储存和分享这些信息，以及我们为您提供的访问、更新、控制和保护这些信息的方式。 本《隐私政策》与您所使用的 大虞建造 服务息息相关，希望您仔细阅读，在需要时，按照本《隐私政策》的指引，作出您认为适当的选择。本《隐私政策》中涉及的相关技术词汇，我们尽量以简明扼要的表述，并提供进一步说明的链接，以便您的理解。</div>
                <div class="mt5" style="font-weight: bolder;">您使用或继续使用我们的服务，即意味着同意我们按照本《隐私政策》收集、使用、储存和分享您的相关信息。</div>
                <div class="mt5">如对本《隐私政策》或相关事宜有任何问题，请通过 jiajia@91mgame.com 与我们联系。</div>
            </div>
        </div>
        <div>
            <div class="mt20 mb20" style="font-weight: bolder;font-size: 2em;color: black;">
                1. 我们收集的信息    
            </div>
            <div>
                <!-- <div>我们或我们的第三方合作伙伴提供服务时，可能会收集、储存和使用下列与您有关的信息。如果您不提供相关信息，可能无法注册成为我们的用户或无法享受我们提供的某些服务，或者无法达到相关服务拟达到的效果。</div> -->
                <div>我们提供的产品和服务需要依赖您的部分信息才得以运行，相应设备权限并不会默认开启，当涉及重要或敏感的设备权限时，我们会在您使用到相应业务功能时，另行弹窗再次征得您的同意后开启；权限开启后，您还可以随时通过设备设置关闭权限；你不同意开启权限，将不会影响其他非相关业务功能的正常使用。针对个人敏感信息，我们会单独征得您的同意后进行处理。因此在您使用大虞建造的时候，需要向我们提供或允许我们收集的必要信息以供我们使用这些信息向您提供基本服务，包括：</div>
                <div class="flex mt5"><div style="font-weight: bolder;">・个人信息</div>，您在注册账户或使用我们的服务时，向我们提供的相关个人信息，我们可能使用或整合您的设备信息（包括设备型号、MAC地址、操作系统版本、设备设置、唯一移动设备识别码（Android ID）、UUID、必要的移动应用列表信息、软硬件及设备、设备环境信息）。</div>
            </div>
        </div>
        <div>
            <div class="mt20 mb20" style="font-weight: bolder;font-size: 2em;color: black;">
                2. 信息的存储   
            </div>
            <div style="font-weight: bolder;color: black;"> 2.1 信息存储的方式和期限</div>
            <div>
                <div class="flex mt5"><div>・</div>我们会通过安全的方式存储您的信息，包括本地存储（例如利用APP进行数据缓存）、数据库和服务器日志。</div>
                <div class="flex mt5 mb10"><div>・</div>一般情况下，我们只会在为实现服务目的所必需的时间内或法律法规规定的条件下存储您的个人信息。</div>
            </div>
            <div style="font-weight: bolder;color: black;"> 2.2 信息存储的地域</div>
            <div>
                <div class="flex mt5"><div>・</div>我们会按照法律法规规定，将境内收集的用户个人信息存储于中国境内。</div>
                <div class="flex mt5 mb10"><div>・</div>目前我们不会跨境传输或存储您的个人信息。将来如需跨境传输或存储的，我们会向您告知信息出境的目的、接收方、安全保证措施和安全风险，并征得您的同意。</div>
            </div>
            <div style="font-weight: bolder;color: black;"> 2.3 产品或服务停止运营时的通知</div>
            <div>
                <div class="flex mt5"><div>・</div>当我们的产品或服务发生停止运营的情况时，我们将以推送通知、公告等形式通知您，并在合理期限内删除您的个人信息或进行匿名化处理，法律法规另有规定的除外。</div>
            </div>
        </div>
        <div>
            <div class="mt20 mb20" style="font-weight: bolder;font-size: 2em;color: black;">
                3. 信息安全   
            </div>
            <div> 
                我们使用各种安全技术和程序，以防信息的丢失、不当使用、未经授权阅览或披露。例如，在某些服务中，我们将利用加密技术（例如SSL）来保护您提供的个人信息。但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全。您需要了解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。
            </div>
        </div>
        <div>
            <div class="mt20 mb20" style="font-weight: bolder;font-size: 2em;color: black;">
                4. 我们如何使用信息   
            </div>
            <div>我们可能将在向您提供服务的过程之中所收集的信息用作下列用途：</div>
            <div>
                <div class="flex"><div>・</div>向您提供服务；</div>
                <div class="flex"><div>・</div>在我们提供服务时，用于身份验证、客户服务、安全防范、诈骗监测、存档和备份用途，确保我们向您提供的产品和服务的安全性；</div>
                <div class="flex"><div>・</div>帮助我们设计新服务，改善我们现有服务；</div>
                <div class="flex"><div>・</div>使我们更加了解您如何接入和使用我们的服务，从而针对性地回应您的个性化需求，例如语言设定、位置设定、个性化的帮助服务和指示，或对您和其他用户作出其他方面的回应；</div>
                <div class="flex"><div>・</div>向您提供与您更加相关的广告以替代普遍投放的广告；</div>
                <div class="flex"><div>・</div>评估我们服务中的广告和其他促销及推广活动的效果，并加以改善；</div>
                <div class="flex"><div>・</div>软件认证或管理软件升级；</div>
                <div class="flex"><div>・</div>让您参与有关我们产品和服务的调查。</div>
                <div class="flex"><div>・</div>第三方 SDK 类服务商：我们相关服务或产品中可能会包含第三方SDK或其他类似的应用程序，如您在我们平台上使用这类由第三方提供的服务或产品时，您同意将由其直接收集和处理您的信息。前述服务商收集和处理信息行为遵守其自身的隐私条款，而不适用于本隐私政策。但我们也会努力审查该第三方的业务准入资质并努力要求该服务商的合法合规性与安全性。为了最大程度保障您的信息安全，我们强烈建议您在使用任何第三方SDK类服务前先行查看其隐私条款。为保障您的合法权益，如果您发现这类SDK或其他类似的应用程序存在风险时，建议您立即终止相关操作并及时与我们取得联系。本应用有使用以下第三方服务，其相关隐私协议可点击对应链接查看：</div>
                <div class="ml20 mt10">1、SDK名称：个推·消息推送
                    <div>使用目的：消息推送，便于及时接收审批请求</div>
                    <div>使用场景：接收APP推送的系统消息</div>
                    <div>收集方式：SDK本机采集</div>
                    <div>收集个人信息类型：存储的个人文件、设备信息（IMEI、MAC、ANDROID_ID、DEVICE_ID、IMSI）、应用已安装列表、网络信息</div>
                    <div>所需权限：1.获取网络状态；3.获取WiFi状态；3.读取手机当前的状态信息；4.允许应用程序写入外部存储设备（如SD卡）；5.控制设备的振动器；6.获取当前运行的任务列表；7.查询设备上安装的所有应用程序包的信息</div>
                    <div>隐私政策链接：http://docs.getui.com/privacy</div>
                    <div>所属公司：每日互动股份有限公司</div>
                    <div>消息推送服务供应商：由每日互动股份有限公司提供推送技术服务，我们可能会将您的设备平台、设备厂商、设备品牌、设备识别码等设备信息，应用列表信息、网络信息以及位置相关信息提供给每日互动股份有限公司，用于为您提供消息推送技术服务。我们在向您推送消息时，我们可能会授权每日互动股份有限公司进行链路调节，相互促活被关闭的SDK推送进程，保障您可以及时接收到我们向您推送的消息。详细内容请访问《个推用户隐私政策》（需将《个推用户隐私政策》超链至：http://docs.getui.com/privacy）</div>
                </div>
                <div class="ml20 mt10">2、SDK名称：华为 HMS push
                    <div>使用目的：确保推送功能得以实现</div>
                    <div>使用场景：接收APP推送的系统消息</div>
                    <div>收集方式：SDK本机采集</div>
                    <div>收集个人信息类型：设备信息（IMEI、ANDROID_ID、DEVICE_ID、IMSI）、应用已安装列表、网络信息</div>
                    <div>所需权限：1.获取网络状态；2.获取WiFi状态；3.安装新的应用程序包;4.允许应用程序在用户界面上显示一个前台服务，该服务在屏幕锁定后仍然运行;5.读取手机当前的状态信息。</div>
                    <div>隐私政策链接：https://developer.huawei.com/consumer/cn/doc/development/HMS-Guides/push-privacy</div>
                    <div>所属公司：华为终端有限公司</div>
                </div>
            </div>
        </div>
        <div>
            <div class="mt20 mb20" style="font-weight: bolder;font-size: 2em;color: black;">
                5. 信息共享   
            </div>
            <div>
                目前，我们不会主动共享或转让您的个人信息至第三方，如存在其他共享或转让您的个人信息或您需要我们将您的个人信息共享或转让至第三方情形时，我们会直接或确认第三方征得您对上述行为的明示同意。
        
                为了投放广告，评估、优化广告投放效果等目的，我们需要向广告主及其代理商等第三方合作伙伴共享您的部分数据，要求其严格遵守我们关于数据隐私保护的措施与要求，包括但不限于根据数据保护协议、承诺书及相关数据处理政策进行处理，避免识别出个人身份，保障隐私安全。
                
                我们不会向合作伙伴分享可用于识别您个人身份的信息（例如您的姓名或电子邮件地址），除非您明确授权。
                
                我们不会对外公开披露所收集的个人信息，如必须公开披露时，我们会向您告知此次公开披露的目的、披露信息的类型及可能涉及的敏感信息，并征得您的明示同意。
                
                随着我们业务的持续发展，我们有可能进行合并、收购、资产转让等交易，我们将告知您相关情形，按照法律法规及不低于本《隐私政策》所要求的标准继续保护或要求新的控制者继续保护您的个人信息。
            </div>
            <div>
                另外，根据相关法律法规及国家标准，以下情形中，我们可能会共享、转让、公开披露个人信息无需事先征得您的授权同意：
            </div>
            <div>
                <div class="flex"><div>・</div>与国家安全、国防安全直接相关的；</div>
                <div class="flex"><div>・</div>与公共安全、公共卫生、重大公共利益直接相关的；</div>
                <div class="flex"><div>・</div>犯罪侦查、起诉、审判和判决执行等直接相关的；</div>
                <div class="flex"><div>・</div>出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</div>
                <div class="flex"><div>・</div>个人信息主体自行向社会公众公开个人信息的；</div>
                <div class="flex"><div>・</div>从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。</div>
            </div>
        </div>
        <div>
            <div class="mt20 mb20" style="font-weight: bolder;font-size: 2em;color: black;">
                6. 您的权利  
            </div>
            <div>
                在您使用我们的服务期间，我们可能会视产品具体情况为您提供相应的操作设置，以便您可以查询、删除、更正或撤回您的相关个人信息，您可参考相应的具体指引进行操作。此外，我们还设置了投诉举报渠道，您的意见将会得到及时的处理。如果您无法通过上述途径和方式行使您的个人信息主体权利，您可以通过本《隐私政策》中提供的联系方式提出您的请求，我们会按照法律法规的规定予以反馈。
            </div>
            <div>
                当您决定不再使用我们的产品或服务时，可以申请注销账户。注销账户后，除法律法规另有规定外，我们将删除或匿名化处理您的个人信息。
            </div>
        </div>
        <div>
            <div class="mt20 mb20" style="font-weight: bolder;font-size: 2em;color: black;">
                7. 变更
            </div>
            <div>
                我们可能适时修订本《隐私政策》的条款。当变更发生时，我们会在版本更新时向您提示新的《隐私政策》，并向您说明生效日期。请您仔细阅读变更后的《隐私政策》内容，若您继续使用我们的服务，即表示您同意我们按照更新后的《隐私政策》处理您的个人信息。
            </div>
        </div>
        <div>
            <div class="mt20 mb20" style="font-weight: bolder;font-size: 2em;color: black;">
                8. 未成年人保护
            </div>
            <div>
                我们鼓励父母或监护人指导未满十八岁的未成年人使用我们的服务。我们建议未成年人鼓励他们的父母或监护人阅读本《隐私政策》，并建议未成年人在提交的个人信息之前寻求父母或监护人的同意和指导。
            </div>
        </div>
        <div>
            <div class="mt20 mb20" style="font-weight: bolder;font-size: 2em;color: black;">
                9. 应用信息
            </div>
            <div>
                利用BIM和云计算、大数据、物联网、移动互联网、人工智能等信息技术引领产业转型升级的业务战略，它结合先进的精益建造理论方法，集成人员、流程、数据、技术和业务系统，实现建筑的全过程，全要素、全参与方的数字化、在线化、智能化
            </div>
        </div>
        <div>
            <div class="mt20 mb20" style="font-weight: bolder;font-size: 2em;color: black;">
                10. 开发者信息
            </div>
            <div>
                <!-- 杭州古木信息科技有限公司 -->
                浙江大虞建设有限公司
            </div>
            <div>
                邮箱:jiajia@91mgame.com
            </div>
        </div>
    </div>
   
</template>

<script>
export default {
    components:{

    },
    data() {
        return {

        }
    },
    created() {

    },
    methods: {

    }
}
</script>

<style scoped>
</style>